import {
  Component,
  ViewContainerRef,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  Renderer2,
  AfterViewInit
} from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { debounceTime } from 'rxjs/operators';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HighlightPipe } from '../../../pipes/highlight-char.pipe';

@Component({
    selector: 'app-form-autocomplete',
    templateUrl: './form-autocomplete.component.html',
    styleUrls: ['./form-autocomplete.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatFormField, NgClass, MatLabel, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, MatError, TranslateModule, HighlightPipe]
})
export class FormAutocompleteComponent implements OnInit, AfterViewInit {
  @ViewChild('autoCompleteInput') autoCompleteInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { read: MatAutocomplete }) matAutocomplete: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;
  selectedOptions: any = [];
  fruitCtrl = new FormControl();
  autocompleteOptions: any[];
  showErrorText = false;
  toHighlight: string;
  showNoDataFound = false;
  constructor(public _eR: ElementRef, public renderer: Renderer2) { }

  scrollEvent = (event: any): void => {
    if((!event.target.className.includes('mat-mdc-autocomplete-panel')) && (!event.target.className.includes('cdk-virtual-scroll-viewport')))
      this.autocomplete.closePanel();
  };
  ngOnInit() {
    window.addEventListener('scroll', this.scrollEvent, true);
    
   this.FormControlName = this.config.name;
   this.autocompleteOptions = this.config.options;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedOptions.push(event.option.viewValue);
    this.toHighlight = '';
    // this.autoCompleteInput.nativeElement.value = '';
    const x = this.FormControlName;
    this.group.patchValue({x: ''});
  }

  DoCheck(): void {
    if (this.matAutocomplete && this.matAutocomplete.panel) {
      const panel = this.matAutocomplete.panel;
      if (panel) {
        panel.nativeElement.parentElement.classList.add(this.config.panelClass);
        const a = panel.nativeElement.parentElement.parentElement.parentElement.children[0].outerHTML;
        if (a !== '<div class="cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing"></div>') {
          panel.nativeElement.parentElement.parentElement.insertAdjacentHTML('beforebegin', '<div class="cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing"></div>');
        }
      }
    }

  }

  validInput(event) {
    const panel = this.matAutocomplete ? this.matAutocomplete.panel : undefined;
    const a = panel.nativeElement.parentElement.parentElement.parentElement.children[0].outerHTML;
    if (a === '<div class="cdk-overlay-backdrop mat-overlay-transparent-backdrop cdk-overlay-backdrop-showing"></div>') {
      panel.nativeElement.parentElement.parentElement.parentElement.children[0].remove();
    }
    const filterValue = this.group.value[this.FormControlName],
    selectedOption = this.config.options.filter(option => option.value.toLowerCase() === filterValue?.toLowerCase());
    if(selectedOption && (selectedOption?.length > 0)&& selectedOption[0]?.hasOwnProperty('CurrencyId')){
      sessionStorage.setItem('TransactionCurrencyId', selectedOption[0].CurrencyId);
      sessionStorage.setItem('SupplierExchangeRate', selectedOption[0].ExchangeRate ?? 1);  
    }
    if (selectedOption?.length < 1) {
      this.showErrorText = true;
      this.config.value = '';
      this.group.controls[this.FormControlName].setErrors({ 'incorrect': true, 'focused': false, 'required': true });
      this.group.controls[this.FormControlName].markAsTouched();
      this.showNoDataFound = false;
    } else {
      this.group.controls[this.FormControlName].setErrors(null);
      this.showErrorText = false;
      this.config.value = this.selectedOptions;
      this.showNoDataFound = false;
    }
  }
  filterOptions(event) {
    const windowHeight = window.innerHeight;
    const targetX = event.target.getBoundingClientRect().top;
    if (((windowHeight - targetX) < 285) ) {
      setTimeout(() => {
        const headerHeight = document.querySelector('.header-notification')?.clientHeight;
        const titleHeight = document.querySelector('.title-view')?.clientHeight;
        let maxHeight = targetX - (headerHeight + titleHeight + 30);
        maxHeight = maxHeight > 50 ? maxHeight : 50;
        const a = document.querySelector('.supplier > .mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible');
        if (a != null && a !== undefined) {
          (<HTMLElement>a).style.maxHeight = maxHeight + 'px';
        } else {
          if (this.config?.callBack) {
            const b = document.querySelector('.mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible');
            if (b) {
              b.classList.add('maxheight-override');
            }
          }
        }
      }, 1);
    } else {
      const a = document.querySelector('.mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible');
      if (a != null && a !== undefined) {
        a.classList.remove('maxheight-override');
      }
    }
    const filterValue = event.target.value.toLowerCase();
    this.toHighlight = event.target.value;
    if (!this.config.hasOwnProperty('callBack')) {
      const filteredArray = this.config.options.filter(option => option.value.toLowerCase().indexOf(filterValue) >= 0)
      this.autocompleteOptions = [...filteredArray];
      this.showNoDataFound = this.autocompleteOptions.length > 0 ? false : true;
    }

  }

  ngAfterViewInit() {
    this.autocompleteOptions = this.config.options;
    const _that = this;
     if (this.config?.callBack) {
      this.group.controls[this.config.name].valueChanges.pipe(debounceTime(500)).subscribe(async val => {
        console.log('Value', val);
        if (val && !this.selectedOptions.includes(val)) {
            await _that.config.callBack(_that.config, val).then(res => {
              this.autocompleteOptions = [...res];
              this.config.options = [...res];
              this.showNoDataFound = this.autocompleteOptions.length > 0 && val? false : true;
              const windowHeight = window.innerHeight;
              const targetX = document.querySelector(`#${this.config.id}`)?.clientTop;
              if (((windowHeight - targetX) < 285) ) {
                setTimeout(() => {
                  const headerHeight = document.querySelector('.header-notification')?.clientHeight;
                  const titleHeight = document.querySelector('.title-view')?.clientHeight;
                  let maxHeight = targetX - (headerHeight + titleHeight + 30);
                  maxHeight = maxHeight > 50 ? maxHeight : 50;
                  const a = document.querySelector('.mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible');
                  if (a != null && a !== undefined) {
                    if (maxHeight === 50) {
                      a.classList.add('maxheight-override');
                    } else {
                      a.classList.remove('maxheight-override');
                      (<HTMLElement>a).style.maxHeight = maxHeight + 'px !important';
                    }
                  }
                }, 100);
              } else {
                const a = document.querySelector('.mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible');
                if (a != null && a !== undefined) {
                  a.classList.remove('maxheight-override');
                }
              }
            });    
        } else {
          this.autocompleteOptions = [];
          this.config.options = [];
          this.selectedOptions = [];
        }
      });
     }
  }

}
